import { motion } from "framer-motion";

const STATS = [
  { value: "4", label: "Centres Horsepower" },
  { value: "5 000+", label: "Véhicules reprogrammés" },
  { value: "6j/7", label: "Support technique" },
  { value: "100%", label: "En ligne & présentiel" },
];

export default function Stats() {
  return (
    <section className="relative bg-[#0a0a0a] border-y border-zinc-900" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4">
          {STATS.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className={`px-4 py-6 ${i !== STATS.length - 1 ? "md:border-r" : ""} ${
                i < 4 ? "border-b md:border-b-0" : ""
              } ${i % 2 === 0 ? "border-r" : ""} md:!border-r border-zinc-800 last:!border-r-0`}
              data-testid="stat-item"
            >
              <div className="font-display text-4xl md:text-5xl text-[#FFD60A] leading-none">
                {s.value}
              </div>
              <div className="mt-3 text-xs md:text-sm uppercase tracking-wider text-zinc-400 leading-snug">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
